import { Component, Input, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProductSearch } from 'src/app/modules/shared/models/products.model';
import { RecentlySearchedService } from '../../shared/services/recently-searched.service';
import { GoogleTagManagerService } from '../../shared/services/google-tag-manager.service';
import { PanelService } from '../../shared/services/api/panel.service';
import { FACEBOOK_EVENT_TYPES } from '../../shared/services/meta-pixel/meta-pixel.model';
import { MetaPixelService } from '../../shared/services/meta-pixel/meta-pixel.service';
import { XGTMService } from '../../shared/services/x-gtm/x-gtm.service';
import { SlicePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { MatAnchor, MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'search-brief-result',
    templateUrl: './search-brief-result.component.html',
    styleUrls: ['./search-brief-result.component.scss'],
    standalone: true,
    imports: [RouterLink, LazyLoadImageModule, MatAnchor, MatButtonModule, SlicePipe]
})
export class SearchBriefResultComponent implements OnInit {
  private dialog = inject(MatDialog);
  private recentlySearchedService = inject(RecentlySearchedService);
  private googleTagManagerService = inject(GoogleTagManagerService);
  private metaPixelService = inject(MetaPixelService);
  private panelService = inject(PanelService);
  private xGtm = inject(XGTMService);

  readonly resultLimit = 3;
  @Input() searchResult: any[];
  @Input() query: string;

  ngOnInit(): void {}

  closeModals() {
    this.dialog.closeAll();
  }

  onNavigate(item: ProductSearch) {
    this.logSearch(item.id);
    this.saveRecentlySearched(this.query);
    this.closeModals();
    this.sendProductEvent(item);
    this.sendSearchEvent(item, this.query);
  }

  private sendSearchEvent(item: ProductSearch, term: string) {
    this.googleTagManagerService.sendAnalytics('search', { term });
    this.metaPixelService.pushEvent(FACEBOOK_EVENT_TYPES.SEARCH, {
      data: {
        content_ids: [`${item.id}`],
        search_string: term,
        contents: [
          {
            id: `${item.id}`,
            quantity: 1
          }
        ],
        content_type: 'product',
        currency: 'no-data',
        value: 1
      }
    });
    this.xGtm.trackSearch(term);
  }

  private logSearch(productId: number) {
    this.panelService
      .logProductSearch({
        product: productId,
        term: this.query
      })
      .subscribe();
  }

  private sendProductEvent(product: ProductSearch) {
    const emptyTxt = '---';
    let analyticData = {
      currency: emptyTxt,
      value: product.id,
      id: product.id,
      name: product.name,
      discount_percent: emptyTxt,
      cashback_percent: emptyTxt,
      source: 'search',
      min_price: emptyTxt,
      max_price: emptyTxt
    };

    this.googleTagManagerService.sendAnalytics('view_product', {
      ...analyticData
    });
  }

  private saveRecentlySearched(keyword: string) {
    if (!keyword) return;
    this.recentlySearchedService.addKeyword(keyword);
  }
}
